// organize-imports-ignore
import './src/prepareReactReanimated';
import 'react-native-reanimated';
import 'expo-dev-client';
import 'expo-asset';
import '@expo/match-media';
import 'react-native-gesture-handler';
import 'react-native-console-time-polyfill';
import { enableAllPlugins } from 'immer';

import 'core-js/features/object/from-entries';

// -------------------------------------------------------------------------
// note(eric): add common important imports above common bootstrap below
// -------------------------------------------------------------------------

enableAllPlugins();

import { polyfillWebCrypto } from 'expo-standard-web-crypto';

import { FlatList, Platform, ScrollView, Text, TextInput } from 'react-native';

if (Platform.OS !== 'web') {
  require('react-native-url-polyfill/auto');
}

Text.defaultProps = {
  ...Text.defaultProps,
  maxFontSizeMultiplier: 2,
};

TextInput.defaultProps = {
  ...TextInput.defaultProps,
  maxFontSizeMultiplier: 2,
  placeholderTextColor: '#9498A2',
};

// https://github.com/facebook/react-native/issues/26610
ScrollView.defaultProps = {
  ...ScrollView.defaultProps,
  scrollIndicatorInsets: { right: 1 },
};
FlatList.defaultProps = {
  ...FlatList.defaultProps,
  scrollIndicatorInsets: { right: 1 },
};

polyfillWebCrypto();
